import PropTypes from 'prop-types';

const allowedTimeSlotScheduleProps = {
  scheduleDate: PropTypes.instanceOf(Date).isRequired,
  dateTimeFormat: PropTypes.object,
  classNames: PropTypes.arrayOf(PropTypes.string),
  getCellContentRenderer: PropTypes.func.isRequired, // should return a function that renders the final content
  noResultsContent: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.element
  ]),
  scheduleData: PropTypes.arrayOf(
    PropTypes.shape({
      columnId: PropTypes.string.isRequired,
      columnName: PropTypes.string.isRequired,
      timeSlots: PropTypes.arrayOf(
        PropTypes.shape({
          startsAt: PropTypes.instanceOf(Date).isRequired,
          endsAt: PropTypes.instanceOf(Date).isRequired,
          isAvailable: PropTypes.bool
        }).isRequired,
      ).isRequired
    }),
  )
};

export { allowedTimeSlotScheduleProps };